import { Navigate, useParams } from "react-router-dom";
import { getCityBySlug, getRetiredRedirect } from "@/data/cities";

/**
 * Catches legacy URL patterns from the previous site:
 *   /job-site-cameras/:slug
 *   /job-site-security-cameras/:slug
 *   /job-site-cameras-qld/:slug
 *
 * Normalises underscores to hyphens, then:
 * - If the slug matches a current location page, 301-style redirect to
 *   /locations/:slug
 * - If the slug was a location page retired in the Sept 2026 consolidation,
 *   redirect to the capital hub that now carries its content
 * - Otherwise, redirect to /locations
 *
 * Note: Cloudflare handles these at the edge via public/_redirects (301) and
 * functions/ (410 for the two oldest patterns). This component is the
 * client-side fallback for anything that reaches the SPA.
 */
export default function LegacyRedirect() {
  const { slug } = useParams<{ slug?: string }>();

  if (!slug) {
    return <Navigate to="/locations" replace />;
  }

  const normalised = slug.toLowerCase().replace(/_/g, "-").trim();

  if (getCityBySlug(normalised)) {
    return <Navigate to={`/locations/${normalised}`} replace />;
  }

  const retired = getRetiredRedirect(normalised);
  if (retired) {
    return <Navigate to={retired} replace />;
  }

  return <Navigate to="/locations" replace />;
}
